import { FunctionComponent } from 'react';
import { MultiValueGenericProps } from 'react-select';
import { components } from 'react-select';
import { SelectOptionData } from '@/components/SelectFloatingLabel/SelectFloatingLabel';
const CustomMultiValueContainer: FunctionComponent<MultiValueGenericProps<SelectOptionData>> = (
  props
) => {
  return (
    <div
      data-testid="select-tag"
      className="m-1 flex items-center justify-center rounded-full border border-primary bg-primary/25 py-1 px-2 text-xs text-primary">
      <components.MultiValueContainer {...props} />
    </div>
  );
};

export default CustomMultiValueContainer;
